// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f5-0";
export var headerCellHover = "_f5-1";